import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CustomButton from "../pages/CustomButton";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import formatDate from "../utils/formatDate";
const ExpenseHistory = () => {
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch expenses from API
  const fetchExpenses = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/api/expenses`, {
        headers: getAuthHeaders(),
      });
      setExpenses(response.data);
    } catch (error) {
      console.error("Error fetching expenses:", error);
      alert("Failed to load expenses");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1 p-6">
        {/* Centered Allowance Button */}
        {/* <div className="flex justify-center mb-6">
          <CustomButton
            label="Add"
            onClick={() => navigate("/admin/Expense-management")}
            variant="add"
          />
        </div> */}

        {/* Expense History Table */}
        <div className="border rounded shadow  table-wrapper">
          <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
          <span class="text-blue-700">Expense </span>
          <span class="text-blue-500">History</span>
        </h1>
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">
              <tr>
                <th className="border p-2">S.No</th>
                <th className="border p-2">State</th>
                <th className="border p-2">Division</th>
                <th className="border p-2">Designation</th>
                <th className="border p-2">Rate/KM</th>
                <th className="border p-2">TA</th>
                <th className="border p-2">DA HQ</th>
                <th className="border p-2">DA Ex-Station</th>
                <th className="border p-2">DA Outstation</th>
                <th className="border p-2">Int. Charge</th>
                <th className="border p-2">VMA</th>
                <th className="border p-2">Fooding</th>
                <th className="border p-2">Other Charges</th>
                <th className="border p-2">Hotel Charges</th>
                <th className="border p-2">Phone</th>
                <th className="border p-2">Remarks</th>
                <th className="border p-2">Start Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="18" className="text-center p-4">
                    Loading...
                  </td>
                </tr>
              ) : expenses.length === 0 ? (
                <tr>
                  <td colSpan="18" className="text-center p-4">
                    No expenses found
                  </td>
                </tr>
              ) : (
                expenses.map((row, index) => (
                  <tr key={row.id} className="text-center">
                    <td className="border p-2">{index + 1}</td>
                    <td className="border p-2">{row.state_name}</td>
                    <td className="border p-2">{row.division_name}</td>
                    <td className="border p-2">{row.designation_name}</td>
                    <td className="border p-2">{row.rate_km}</td>
                    <td className="border p-2">{row.ta}</td>
                    <td className="border p-2">{row.da_hq}</td>
                    <td className="border p-2">{row.da_exstation}</td>
                    <td className="border p-2">{row.da_outstation}</td>
                    <td className="border p-2">{row.int_charge}</td>
                    <td className="border p-2">{row.vma}</td>
                    <td className="border p-2">{row.fooding}</td>
                    <td className="border p-2">{row.other_charges}</td>
                    <td className="border p-2">{row.hotel_charges}</td>
                    <td className="border p-2">{row.phone}</td>
                    <td className="border p-2">{row.remarks}</td>
                    <td className="border p-2">{formatDate(row.start_date)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default ExpenseHistory;

